import { createRouter, createWebHistory } from "vue-router";
//import Default from "../views/dashboards/Default.vue";
import Sales from "../views/dashboards/Sales.vue";
import Overview from "../views/pages/profile/Overview.vue";
import Projects from "../views/pages/profile/Projects.vue";
import Timeline from "../views/pages/projects/Timeline.vue";
import Pricing from "../views/pages/Pricing.vue";
import RTL from "../views/pages/Rtl.vue";
import Charts from "../views/pages/Charts.vue";
import Notifications from "../views/pages/Notifications.vue";
import Kanban from "../views/applications/Kanban.vue";
import Wizard from "../views/applications/wizard/Wizard.vue";
import DataTables from "../views/applications/DataTables.vue";
import Calendar from "../views/applications/Calendar.vue";
import NewProduct from "../views/ecommerce/products/NewProduct.vue";
import EditProduct from "../views/ecommerce/products/EditProduct.vue";
import ProductPage from "../views/ecommerce/products/ProductPage.vue";
import OrderDetails from "../views/ecommerce/orders/OrderDetails";
import OrderList from "../views/ecommerce/orders/OrderList";
import NewUser from "../views/pages/users/NewUser.vue";
//import Settings from "../views/pages/account/Settings.vue";
import Billing from "../views/pages/account/Billing.vue";
import Invoice from "../views/pages/account/Invoice.vue";
import Widgets from "../views/pages/Widgets.vue";
import Basic from "../views/auth/signin/Basic.vue";
import Cover from "../views/auth/signin/Cover.vue";
import Illustration from "../views/auth/signin/Illustration.vue";
import ResetCover from "../views/auth/reset/Cover.vue";
import SignupCover from "../views/auth/signup/Cover.vue";

// 내가 만든 페이지
import WebSocketTest from "@/views/tests/WebSocketTest.vue";
import SpontaneousSpeakingTest from "@/views/tests/SpontaneousSpeakingTest.vue";
import AIWritingTest from "@/views/tests/AIWritingTest.vue";
import AcademicClasses from "@/views/academic/AcademicClasses.vue";
import AcademicClassesDetail from "@/views/academic/AcademicClassesDetail.vue";
import AcademicEvaluations from "@/views/academic/AcademicEvaluations.vue";
import AcademicQuestionBank from "@/views/academic/AcademicQuestionBank.vue";
import ImageAssetPopup from "@/views/popup/ImageAssetPopup.vue";

import HelpDeskFAQs from "@/views/helpDesk/HelpDeskFAQs.vue";
import HelpDeskInquiry from "@/views/helpDesk/HelpDeskInquiry.vue";

import InstructorAccessRequest from "@/views/instructor/InstructorAccessRequest.vue";
import InstructorAccessStatus from "@/views/instructor/InstructorAccessStatus.vue";
import MaterialsBooks from "@/views/materials/MaterialsBooks.vue";
import MaterialsBooksDetail from "@/views/materials/MaterialsBooksDetail.vue";
import OrgInstructors from "@/views/organization/OrgInstructors.vue";
import OrgInstructorClassrooms from "@/views/organization/OrgInstructorClassrooms.vue";
import OrgVouchers from "@/views/organization/OrgVouchers.vue";

import store from "@/store"; // Vuex store를 가져옵니다.

const routes = [
  {
    path: "/",
    redirect: "/dashboards/dashboard-default",
  },
  {
    path: "/dashboards",
    name: "Dashboards",
    children: [
      {
        path: "dashboard-default",
        name: "Default",
        //component: Default,
        component: Sales, // sales로 바꾸기
      },
      {
        path: "sales",
        name: "Sales",
        component: Sales,
      },
    ],
  },  
  {
    path: "/pages",
    name: "Pages",
    children: [
      {
        path: "profile/overview",
        name: "Profile Overview",
        component: Overview,
      },
      {
        path: "profile/projects",
        name: "All Projects",
        component: Projects,
      },
      {
        path: "projects/timeline",
        name: "Timeline",
        component: Timeline,
      },
      {
        path: "pricing-page",
        name: "Pricing Page",
        component: Pricing,
      },
      {
        path: "rtl-page",
        name: "RTL",
        component: RTL,
      },
      {
        path: "charts",
        name: "Charts",
        component: Charts,
      },
      {
        path: "widgets",
        name: "Widgets",
        component: Widgets,
      },
      {
        path: "notifications",
        name: "Notifications",
        component: Notifications,
      },
      {
        path: "users/new-user",
        name: "New User",
        component: NewUser,
      },
      {
        path: "account/billing",
        name: "Billing",
        component: Billing,
      },
      {
        path: "account/invoice",
        name: "Invoice",
        component: Invoice,
      },
    ],
  },
  {
    path: "/applications",
    name: "Applications",
    children: [
      {
        path: "kanban",
        name: "Kanban",
        component: Kanban,
      },
      {
        path: "wizard",
        name: "Wizard",
        component: Wizard,
      },
      {
        path: "data-tables",
        name: "Data Tables",
        component: DataTables,
      },
      {
        path: "calendar",
        name: "Calendar",
        component: Calendar,
      },
    ],
  },
  {
    path: "/ecommerce",
    name: "Ecommerce",
    children: [
      {
        path: "products/new-product",
        name: "New Product",
        component: NewProduct,
      },
      {
        path: "products/edit-product",
        name: "Edit Product",
        component: EditProduct,
      },
      {
        path: "products/product-page",
        name: "Product Page",
        component: ProductPage,
      },
      {
        path: "orders/order-details",
        name: "Order Details",
        component: OrderDetails,
      },
      {
        path: "orders/order-list",
        name: "Order List",
        component: OrderList,
      },
    ],
  },
  {
    path: "/authentication",
    name: "Authentication",
    children: [
      {
        path: "signin/basic",
        name: "Signin Basic",
        component: Basic,
        meta: { layout: 'empty' },
      },
      {
        path: "signin",
        name: "Signin Cover",
        component: Cover,
        meta: { layout: 'empty' },
      },
      {
        path: "signin/illustration",
        name: "Signin Illustration",
        component: Illustration,
        meta: { layout: 'empty' },
      },
      {
        path: "reset/cover",
        name: "Reset Cover",
        component: ResetCover,
        meta: { layout: 'empty' },
      },
      {
        path: "signup",
        name: "Signup Cover",
        component: SignupCover,
        meta: { layout: 'empty' },
      },
      {
        path: "/logout",
        name: "Logout",
        beforeEnter(to, from, next) {
          //console.log("로그아웃 시작");
          store
            .dispatch("auth/logout") // Vuex Store에서 로그아웃 액션 호출
            .then(() => {
              //console.log("로그아웃 완료");
              // 로그아웃 후 로그인 페이지로 리다이렉트
              next({ path: "/authentication/signin" });
            })
            .catch((err) => {
              console.error("로그아웃 중 오류 발생:", err);
              // 오류가 발생해도 로그인 페이지로 이동
              next({ path: "/authentication/signin" });
            });
        },
      }
    ],
  },
  // Error403 라우트 제거됨 - 권한 체크 기능 제거
  // 내가 새롭게 만든 라우트
  {
    path: "/academic",
    name: "Academic",
    children: [
      {
        path: "classes",
        name: "AcademicClasses",
        component: AcademicClasses,
      },
      {
        path: "evaluations",
        name: "AcademicEvaluations",
        component: AcademicEvaluations,
      },
      {
        path: "questionBank",
        name: "AcademicQuestionBank",
        component: AcademicQuestionBank,
      },
      {
        path: "classesDetail",
        name: "AcademicClassesDetail",
        component: AcademicClassesDetail,
      }
    ]
  },
  // 강사 권한 요청 (learner 계정도 접근 가능 — main.js 가드 참고)
  {
    path: "/instructor",
    name: "Instructor",
    children: [
      {
        path: "access-request",
        name: "InstructorAccessRequest",
        component: InstructorAccessRequest,
        meta: { layout: 'empty' },
      },
      {
        path: "access-status",
        name: "InstructorAccessStatus",
        component: InstructorAccessStatus,
        meta: { layout: 'empty' },
      },
    ],
  },
  // 자료실 (승인 강사 전용)
  {
    path: "/materials",
    name: "Materials",
    children: [
      {
        path: "books",
        name: "MaterialsBooks",
        component: MaterialsBooks,
      },
      {
        path: "booksDetail",
        name: "MaterialsBooksDetail",
        component: MaterialsBooksDetail,
      },
    ],
  },
  // 기관 관리 — 기관 Master(승인 강사 중 관리자가 지정)에게만 메뉴 노출. 진입 가드는 main.js (organization/isMaster)
  {
    path: "/organization",
    name: "Organization",
    children: [
      {
        path: "instructors",
        name: "OrgInstructors",
        component: OrgInstructors,
      },
      {
        path: "instructors/classrooms",
        name: "OrgInstructorClassrooms",
        component: OrgInstructorClassrooms,
      },
      {
        path: "vouchers",
        name: "OrgVouchers",
        component: OrgVouchers,
      },
    ],
  },
  {
    path: "/helpDesk",
    name: "Help Desk",
    children: [
      {
        path: "faqs",
        name: "HelpDeskFAQs",
        component: HelpDeskFAQs,
      },
      {
        path: "inquiry",
        name: "HelpDeskInquiry",
        component: HelpDeskInquiry,
      }
    ]
  },
  // 테스트 페이지 추가
  {
    path: "/tests",
    name: "Tests",
    children: [
      {
        path: "websocket",
        name: "WebSocketTest",
        component: WebSocketTest,
      },
      {
        path: "spontaneousSpeaking",
        name: "SpontaneousSpeakingTest",
        component: SpontaneousSpeakingTest,
      },
      {
        path: "aiWriting",
        name: "AIWritingTest",
        component: AIWritingTest,
      },
    ]
  },
  // 팝업 페이지 (레이아웃 없음)
  {
    path: "/popup/image-assets",
    name: "ImageAssetPopup",
    component: ImageAssetPopup,
    meta: { layout: 'empty' } // 레이아웃 없이 컴포넌트만 표시
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;
